import { isRecord, parseNonEmptyString } from './parseGiftCardDetails'

export interface GiftCardRecipient {
  name: string | null
  email: string | null
  senderName: string | null
  message: string | null
}

interface CheckoutConsumer {
  givenNames?: string | null
  surname?: string | null
  email?: string | null
}

const joinNames = (...names: unknown[]): string | null => {
  const joined = names
    .map(parseNonEmptyString)
    .filter((name): name is string => name !== null)
    .join(' ')
  return joined === '' ? null : joined
}

export const parseGiftCardRecipient = (custom: unknown, consumer?: CheckoutConsumer | null): GiftCardRecipient | null => {
  const data = isRecord(custom) ? custom : {}

  const recipient: GiftCardRecipient =
    data.isGift === true
      ? {
          name: parseNonEmptyString(data.recipientName),
          email: parseNonEmptyString(data.recipientEmail),
          senderName: parseNonEmptyString(data.senderName),
          message: parseNonEmptyString(data.recipientMessage),
        }
      : {
          name: joinNames(consumer?.givenNames, consumer?.surname) ?? parseNonEmptyString(data.senderName),
          email: parseNonEmptyString(consumer?.email) ?? parseNonEmptyString(data.senderEmail),
          senderName: null,
          message: null,
        }

  return recipient.name === null && recipient.email === null ? null : recipient
}
